import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { Anchor, Container, Stack, Text, Title } from "@mantine/core";
import { AnalyticsObserver } from "@/features/analytics/AnalyticsObserver";
import { AvailabilityBoundary } from "@/features/app-info/AvailabilityBoundary";
import { AppHeader } from "@/components/AppHeader";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => <><AnalyticsObserver /><AppHeader /><AvailabilityBoundary><Outlet /></AvailabilityBoundary></>,
  notFoundComponent: () => (
    <Container py="xl">
      <Stack>
        <Title order={1}>Page not found</Title>
        <Text>This URL does not match a browser route.</Text>
        <Anchor href="/">Home</Anchor>
      </Stack>
    </Container>
  ),
});
